<template>
  <img
      :src="getFlagFile()"
      :title="getFlagTitle()"
      class="flag"
  />
</template>

<script>
import flags from '@/assets/flags.json'
import _ from 'lodash'
import {logger} from "@/services/logger.service";

export default {
  props: ['country'],
  data: function () {
    return {
      regionNames: new Intl.DisplayNames(['en'], {type: 'region'})
    }
  },
  methods: {
    getFlagFile: function () {
      //logger.debug("Country code: " + this.country)
      if (this.country && _.indexOf(flags, this.country.toLowerCase().replace(/\s+/g, '')) > -1) {
        return require(`@/assets/flags/${this.country.toLowerCase().replace(/\s+/g, '')}.png`)
      } else {
        return require('@/assets/flags/no_flag.png')
      }
    },
    getFlagTitle: function () {
      let countryName = 'No country';
      if (this.country && _.indexOf(flags, this.country.toLowerCase()) > -1) {
        countryName = this.country;
      }
      try {
        countryName = this.regionNames.of(countryName);
      } catch {
        logger.debug("Could not resolve country code: " + countryName)
      }
      return countryName;
    }
  }
}
;
</script>

<style>
.flag {
  border-radius: 20px;
  width: 25px;
  height: 25px
}
</style>
